import { render, staticRenderFns } from "./ForwardToChatbot.vue?vue&type=template&id=4680f63c"
import script from "./ForwardToChatbot.vue?vue&type=script&lang=js"
export * from "./ForwardToChatbot.vue?vue&type=script&lang=js"
import style0 from "./ForwardToChatbot.vue?vue&type=style&index=0&id=4680f63c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports